module.exports = __webpack_public_path__ + "Roboto-Medium.1561b424aaef2f704bbd.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Medium.woff2
// module id = 610
// module chunks = 2